import { get } from 'lodash'

export const BaseMixin = {
  props: {
    headers: { type: Array, default: () => [], required: true },
    itemKey: { type: String, default: 'id' },
    loading: Boolean,
    items: { type: Array, default: () => [], required: true },
    orderBys: { default: () => [], type: Array },
    pagination: { type: Object, default: () => ({}) },
    isScrollLoad: Boolean,
  },
  computed: {
    slotItemRow() {
      return Object.keys(this.$scopedSlots).filter((x) => x.includes('item'))
    },
    slotItemHeader() {
      return Object.keys(this.$scopedSlots).filter((x) => x.includes('header'))
    },
  },
  data: () => ({}),
  watch: {},
  methods: {
    onLoadMore(entries, observer, isIntersecting) {
      if (isIntersecting && !this.loading) this.$emit('loadMoreData')
    },
    emit(e, eventName, prop) {
      this.$emit(eventName, prop || e)
    },
  },
}
export default BaseMixin
export function getValueRow(obj, header) {
  let prop = header.value
  let value = get(obj, prop, '')
  if (header.filter) {
    value = this.$options.filters[header.filter](value)
  }
  if (header.format) {
    value = header.format(obj, header, value)
  }
  return value
}
